import React, { useContext, useEffect, useRef, useState } from "react";
import { CgCloseO, CgProfile } from "react-icons/cg";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CoinIcon from "assets/icons/coin.svg";
import FinanceIcon from "assets/icons/finance.svg";
import { UserInfoContext } from "contexts/userInfo";
import Users from "services/apis/usersAPI";
import Wallets from "services/apis/walletsAPI";
import rialConvertToToman from "utils/convertRialToToman/convertRialToToman";
import priceSeparator from "utils/priceSeparator/PriceSeparator";
import {
  HeaderContainer,
  PriceInfo,
  PriceInfoContainer,
  ProfileIcon,
  ProfileMobileWrapper,
  ProfileModal,
  ProfileName,
  ProfileWrapper,
  Recharge,
  TariffContainer,
  VerticalLine,
  WalletDiscript,
  WalletInfo,
  WalletValue,
} from "./index.styled";
import { logger } from "utils/logger/logger";

function Header({}) {
  const Navigate = useNavigate();
  const [selected, setSelected] = useState(false);
  const [show, setShow] = useState(false);
  const userData = useContext(UserInfoContext);

  const toggleHandler = (e) => {
    e.stopPropagation();
    setSelected(!selected);
  };
  const userInfoRef = useRef(null);
  const tariffRef = useRef(null);
  const showHandler = () => {
    setShow(!show);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userInfoRef.current && !userInfoRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [userInfoRef]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tariffRef.current && !tariffRef.current.contains(event.target)) {
        setSelected(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [tariffRef]);

  const ExitHandler = async () => {
    logger.log()("EXIT Handler");
    const response = await new Users().postLogout();
    logger.log()(response);
    if (response.type) {
      Navigate("/");
      setSelected(false);
      localStorage.clear();
    } else {
      toast.error(response.message);
    }
  };

  const getUsersInfo = async () => {
    if (userData.walletData === null) {
      const walletResponse = await new Wallets().getWallet();

      if (walletResponse.type) {
        userData.setWalletData(walletResponse?.data.data.balance);
      }
    }

    if (userData.usersInfo.length === 0) {
      const profileResponse = await new Users().getProfile();

      if (profileResponse.type) {
        userData.setUsersInfo(profileResponse.data?.data);
      }
    }
  };

  useEffect(() => {
    getUsersInfo();
  }, []);

  return (
    <>
      <HeaderContainer>
        <ProfileMobileWrapper
          onClick={(e) => toggleHandler(e)}
          className={selected ? "show" : ""}
          ref={tariffRef}
        >
          <ProfileIcon>
            <MdOutlineKeyboardArrowDown className={selected ? "open" : ""} />
          </ProfileIcon>
          <ProfileName color="#27548C">
            {userData.usersInfo ? userData.usersInfo.mobile : ""}{" "}
          </ProfileName>
        </ProfileMobileWrapper>
        <ProfileModal className={!selected ? "hidden" : ""}>
          <Link to="/edit-account">
            <ProfileWrapper>
              <CgProfile />
              پروفایل
            </ProfileWrapper>
          </Link>
          <ProfileWrapper onClick={() => ExitHandler()}>
            <CgCloseO />
            خروج
          </ProfileWrapper>
        </ProfileModal>

        <PriceInfoContainer>
          <PriceInfo
            color="#27548C"
            onClick={showHandler}
            className={show ? "show" : ""}
            ref={userInfoRef}
          >
            <img src={FinanceIcon} alt="finance icon" />
            <div className="title">تعرفه ها</div>
            <ProfileIcon>
              <MdOutlineKeyboardArrowDown className={show ? "open" : ""} />
            </ProfileIcon>

            <TariffContainer className={!show ? "hidden" : ""}>
              {userData.usersInfo.Plan?.data?.rangeOfPrice?.map(
                (item, index) => (
                  <div key={index}>
                    هزینه هر کاراکتر از <span>{item.from}</span> تا{" "}
                    <span>{item.to === "Infinity" ? "بی نهایت" : item.to}</span>{" "}
                    <span className="price">
                      {rialConvertToToman(`${item.price}`)} تومان
                    </span>{" "}
                    می باشد.
                  </div>
                )
              )}
            </TariffContainer>
            {/* <p> هزینه هر <span>1000</span>  کارکتر 
                         <Price color="#629EE8"> {priceSeparator(userData.usersInfo.Plan?.data.costPerCharacter * 1000)} ریال </Price>
                        می باشد.</p> */}
          </PriceInfo>
          <Recharge color="#629EE8">
            <Link to="/wallet">افزایش اعتبار &#62;</Link>
          </Recharge>
        </PriceInfoContainer>
        <VerticalLine>&nbsp;</VerticalLine>
        <WalletInfo>
          <div>
            <img src={CoinIcon} alt="coin icon" />
            <WalletDiscript color="#27548C">اعتبار کیف پول</WalletDiscript>
          </div>
          <div>
            <WalletValue color="#27548C">
              {isNaN(userData?.walletData) === false &&
                priceSeparator(
                  rialConvertToToman(+userData?.walletData).toFixed()
                )}{" "}
              تومان
            </WalletValue>
          </div>
        </WalletInfo>
      </HeaderContainer>
    </>
  );
}

export const MemoizedHeader = React.memo(Header);
